import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Subscription, tap } from 'rxjs';
import { UserModel } from '../core/models/user.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit, OnDestroy {
    userName: string;
    password: string;

    login: Subscription;

    constructor(private loginService: LoginService, private router: Router) {}
    ngOnInit(): void {
        this.loginService.autoLogin();
    }
    onSignin(): void {
        const data = {
            email: this.userName,
            password: this.password,
            model: 'webapp'
        };
        this.login = this.loginService
            .login(data)
            .pipe(
                tap((response) => {
                    const user = new UserModel();
                    user.email = response.user.email;
                    user.id = response.user.id;
                    user.name = response.user.name;
                    user.token = response.key;
                    this.loginService.userSubject.next(user);
                    localStorage.setItem('user', JSON.stringify(user));
                    this.router.navigate(['/']);
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.login?.unsubscribe();
    }
}
